import type { ApproveType } from '../../types/approval';

const getHistoriesRowNodeId = (params: ApproveType): string => {
  const rowNodeId: string = ('id' + params.id + '-organizationId' + params.organizationId + '-applicantEmail' + params.applicantEmail + '-requestDate' + params.requestDate)
    .split('@')
    .join()
    .split(':')
    .join();
  // console.log(rowNodeId);
  return rowNodeId;
};

export default getHistoriesRowNodeId;
